// Module
var code = "<archive-page resource=\"vm.resource\"></archive-page>\n";
// Exports
module.exports = code;